import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Compass, Trophy, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { NoahMascot } from './NoahMascot';
import { openAppTour } from './AppTour';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TourProgressCard = () => {
  const [prog, setProg] = useState(null);
  const [variant, setVariant] = useState('basic');

  const load = useCallback(async () => {
    try {
      const sub = await axios.get(`${API}/subscriptions/current`).then((r) => r.data).catch(() => null);
      const v = sub && sub.status && sub.status !== 'trial' ? 'plus' : 'basic';
      setVariant(v);
      const { data } = await axios.get(`${API}/tour/progress?variant=${v}`);
      setProg(data);
    } catch { /* silencioso */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const done = prog?.completed_steps?.length || 0;
  const total = prog?.total || (variant === 'plus' ? 6 : 7);
  const pct = Math.min(100, Math.round((done / total) * 100));
  const finished = prog?.finished;

  return (
    <Card className="bg-card/80 backdrop-blur border-white/10" data-testid="tour-launcher-card">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center gap-2">
          <Compass className="w-4 h-4 text-brand-green" />
          <h3 className="font-semibold text-foreground">
            {variant === 'plus' ? 'Tour Plus' : 'Tour de funciones'}
          </h3>
          {finished && (
            <Badge className="ml-auto bg-brand-butter text-brand-deep border-none gap-1" data-testid="tour-badge">
              <Trophy className="w-3 h-3" /> Explorador DEAL
            </Badge>
          )}
        </div>

        <div className="flex items-center gap-4">
          {finished && <NoahMascot mood="happy" size={70} className="shrink-0" />}
          <div className="min-w-0 flex-1 space-y-2">
            <p className="text-sm text-muted-foreground">
              {finished
                ? 'Completaste el recorrido entero. Puedes repetirlo cuando quieras.'
                : 'Noah te enseña la app pulsando contigo los botones reales. Avanza y gana tu insignia.'}
            </p>
            <div className="h-2 rounded-full bg-muted overflow-hidden" data-testid="tour-progress-bar">
              <div className="h-full bg-brand-green transition-all duration-500" style={{ width: `${pct}%` }} />
            </div>
            <p className="text-[11px] text-muted-foreground" data-testid="tour-progress-label">
              {done} de {total} pasos {finished && <CheckCircle2 className="w-3 h-3 inline text-brand-green" />}
            </p>
          </div>
        </div>

        <Button onClick={openAppTour} data-testid="open-tour-btn" className="gap-2 w-full sm:w-auto">
          <Compass className="w-4 h-4" /> {finished ? 'Repetir el tour' : done > 0 ? 'Continuar el tour' : 'Ver el tour'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default TourProgressCard;
